// extracted by mini-css-extract-plugin
module.exports = {"grid":"product-grid_grid__YFMM_"};